import React from "react";


// MUI components - starts
import { FormControlLabel, Checkbox, FormGroup} from '@mui/material';
import PDFsContainerComponent from "../pdf-container-component/hoa-pool-access-form-pdf-container";
// MUI components - ends

export default function HoaOnboardingModalView({ activeState, onboardingDataState }:any) {
    return (
        <>
            {
                activeState == 1 ?
                <ClientDirectoryView onboardingDataState={onboardingDataState}/>
                : activeState == 2 ?
                <PortalSearchView onboardingDataState={onboardingDataState}/>
                : activeState == 3 ?
                <EmailHoaView onboardingDataState={onboardingDataState}/>
                : activeState == 4 ?
                <CallHoaView onboardingDataState={onboardingDataState}/>
                :
                <></>
            }
        </>
    )
}

const ClientDirectoryView = ({onboardingDataState}:any) => {
    const { clientDirectory } = onboardingDataState;
    const { data } = clientDirectory;

    return (
        <>
            {
                clientDirectory.isCompleted &&
                <>
                    <div className="onboarding-header bold" style={{ marginBottom: "10px" }}>Last Updated By</div>
                    <div className="onboarding-text nomral" style={{ marginBottom: "30px" }}>{`${clientDirectory["completedBy"]} | ${clientDirectory["completedAt"]}`}</div>
                </>
            }

            <div className="onboarding-header bold" style={{ marginBottom: "15px" }}>Documents</div>
            {
                data["documents"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        data["documents"].map((file : any, index: number)=>{
                            return <PDFsContainerComponent key={index} file={file} folder={"onboardingData"}/>
                        })
                    }
                </div>
                : 'N/A'
            }
            <div className="onboarding-header bold" style={{ marginTop: "30px" }}>Hyperlink</div>
            <div className="onboarding-text nomral" style={{ marginTop: "10px" }}>{data["hyperLink"] || 'N/A'}</div>
            <div className="onboarding-header bold" style={{ marginTop: "30px" }}>Remarks</div>
            <div className="onboarding-text nomral" style={{ marginTop: "10px" }}>{data["remarks"] || 'N/A'}</div>
            <FormGroup style={{ marginTop: "30px" }}>
                <FormControlLabel 
                    control={
                        <Checkbox 
                            name={"isDataUnavailable"}
                            checked={data["isDataUnavailable"]}
                            onClick={(e) => e.preventDefault()}
                        />
                    } 
                    label="No details are available" 
                />
            </FormGroup>
        </>
    )
}

const PortalSearchView = ({onboardingDataState}:any) => {
    const { portalSearch } = onboardingDataState;
    const { data } = portalSearch;

    return (
        <>
            {
                portalSearch.isCompleted &&
                <>
                    <div className="onboarding-header bold" style={{ marginBottom: "10px" }}>Last Updated By</div>
                    <div className="onboarding-text nomral" style={{ marginBottom: "30px" }}>{`${portalSearch["completedBy"]} | ${portalSearch["completedAt"]}`}</div>
                </>
            }
            <div className="onboarding-header bold">Portal Link</div>
            <div className="onboarding-text nomral" style={{ marginTop: "10px" }}>{data["portalLink"] || 'N/A'}</div>
            <div className="onboarding-header bold" style={{ marginTop: "30px", marginBottom: "15px" }}>Documents</div>
            {
                data["documents"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        data["documents"].map((file : any, index: number)=>{
                            return <PDFsContainerComponent key={index} file={file} folder={"onboardingData"}/>
                        })
                    }
                </div>
                : 'N/A'
            }
            <div className="onboarding-header bold" style={{ marginTop: "30px" }}>Remarks</div>
            <div className="onboarding-text nomral" style={{ marginTop: "10px" }}>{data["remarks"] || 'N/A'}</div>
            <FormGroup style={{ marginTop: "30px" }}>
                <FormControlLabel 
                    control={
                        <Checkbox 
                            name={"isDataUnavailable"}
                            checked={data["isDataUnavailable"]}
                            onClick={(e) => e.preventDefault()}
                        />
                    } 
                    label="No details are available" 
                />
            </FormGroup>
        </>
    )
}

const EmailHoaView = ({onboardingDataState}:any) => {
    const { emailHoa } = onboardingDataState;
    const { data } = emailHoa;

    return (
        <>
            {
                emailHoa.isCompleted &&
                <>
                    <div className="onboarding-header bold" style={{ marginBottom: "10px" }}>Last Updated By</div>
                    <div className="onboarding-text nomral" style={{ marginBottom: "30px" }}>{`${emailHoa["completedBy"]} | ${emailHoa["completedAt"]}`}</div>
                </>
            }
            <div className="onboarding-header bold">Email Source ID</div>
            <div className="onboarding-text nomral" style={{ marginTop: "10px" }}>{data["emailSourceId"] || 'N/A'}</div>
            <div className="onboarding-header bold" style={{ marginTop: "30px" }}>Obtained Information</div>
            <div className="onboarding-text nomral" style={{ marginTop: "10px" }}>{data["obtainedInformation"] || 'N/A'}</div>
            <div className="onboarding-header bold" style={{ marginTop: "30px", marginBottom: "15px" }}>Documents</div>
            {
                data["documents"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        data["documents"].map((file : any, index: number)=>{
                            return <PDFsContainerComponent key={index} file={file} folder={"onboardingData"}/>
                        })
                    }
                </div>
                : 'N/A'
            }
            <div className="onboarding-header bold" style={{ marginTop: "30px", marginBottom: "15px" }}>Screenshot</div>
            {
                data["screenshot"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        data["screenshot"].map((file : any, index: number)=>{
                            return <PDFsContainerComponent key={index} file={file} folder={"onboardingData"}/>
                        })
                    }
                </div>
                : 'N/A'
            }
            <div className="onboarding-header bold" style={{ marginTop: "30px" }}>Remarks</div>
            <div className="onboarding-text nomral" style={{ marginTop: "10px" }}>{data["remarks"] || 'N/A'}</div>
        </>
    )
}

const CallHoaView = ({onboardingDataState}:any) => {
    const { callHoa } = onboardingDataState;
    const { data } = callHoa;

    return (
        <>
            {
                callHoa.isCompleted &&
                <>
                    <div className="onboarding-header bold" style={{ marginBottom: "10px" }}>Last Updated By</div>
                    <div className="onboarding-text nomral" style={{ marginBottom: "30px" }}>{`${callHoa["completedBy"]} | ${callHoa["completedAt"]}`}</div>
                </>
            }
            <div className="onboarding-header bold" style={{ marginBottom: "15px" }}>Screenshot</div>
            {
                data["screenshot"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        data["screenshot"].map((file : any, index: number)=>{
                            return <PDFsContainerComponent key={index} file={file} folder={"onboardingData"}/>
                        })
                    }
                </div>
                : 'N/A'
            }
            <div className="onboarding-header bold" style={{ marginTop: "30px" }}>Receiver's Contact Info</div>
            <div className="onboarding-header bold" style={{ marginTop: "10px", fontSize: "12px" }}>Phone</div>
            <div className="onboarding-text nomral">{data["phone"] || 'N/A'}</div>
            <div className="onboarding-header bold" style={{ marginTop: "10px", fontSize: "12px" }}>Email</div>
            <div className="onboarding-text nomral">{data["email"] || 'N/A'}</div>

            <div className="onboarding-header bold" style={{ marginTop: "30px" }}>Obtained Information</div>
            <div className="onboarding-text nomral" style={{ marginTop: "10px" }}>{data["obtainedInformation"] || 'N/A'}</div>

            <div className="onboarding-header bold" style={{ marginTop: "30px", marginBottom: "15px" }}>Documents</div>
            {
                data["documents"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        data["documents"].map((file : any, index: number)=>{
                            return <PDFsContainerComponent key={index} file={file} folder={"onboardingData"}/>
                        })
                    }
                </div>
                : 'N/A'
            }
            <div className="onboarding-header bold" style={{ marginTop: "30px" }}>Remarks</div>
            <div className="onboarding-text nomral" style={{ marginTop: "10px" }}>{data["remarks"] || 'N/A'}</div>
        </>
    )
}